/* WaterFun collection page (approved 2026-09-29): the "הוספה לסל" pill on
 * bulk quick-add cards (snippets/card-product.liquid).
 *
 * The pill never talks to the cart itself. It presses Dawn's own "+"
 * button inside the same <quick-add-bulk>, so adding to the cart, quantity
 * rules, errors and the cart drawer stay 100% stock Dawn behavior.
 *
 * quick-add-bulk.js replaces the element's innerHTML after every cart
 * update, so everything here is delegated from the document (no
 * per-button listeners to re-bind).
 *
 * data-wf-open on the <quick-add-bulk> host shows the stepper right away,
 * before the cart round-trip re-renders it with the new quantity. It is
 * cleared again when the shopper steps back down to 0, so the pill
 * returns instead of a "0" box.
 */
(function () {
  'use strict';
  if (window.wfCollectionInit) return;
  window.wfCollectionInit = true;

  document.addEventListener('click', function (event) {
    var addPill = event.target.closest('[data-wf-bulk-add]');
    if (addPill) {
      var host = addPill.closest('quick-add-bulk');
      var plus = host && host.querySelector('.quantity__button[name="plus"]');
      if (!plus) return;
      host.setAttribute('data-wf-open', '');
      plus.click();
      /* Keep keyboard users on a live control: the pill is now hidden. */
      var input = host.querySelector('.quantity__input');
      if (input) input.focus({ preventScroll: true });
      return;
    }

    /* Bubble phase: Dawn's quantity-input handler (on the element) has
       already updated the value by the time this document listener runs. */
    var minus = event.target.closest('quick-add-bulk .quantity__button[name="minus"]');
    if (minus) {
      var bulk = minus.closest('quick-add-bulk');
      var qty = bulk && bulk.querySelector('.quantity__input');
      if (qty && Number(qty.value) === 0) bulk.removeAttribute('data-wf-open');
    }

    var moreBtn = event.target.closest('[data-wf-more-btn]');
    if (moreBtn) showMore(moreBtn);
  });

  /* "In stock first" (2026-10-07): the section renders the whole collection
     (in stock first, then sold out) and marks every card after the first
     batch with .wf-stock-more (hidden while JavaScript runs - see
     waterfun-collection.css). Each click reveals the next batch of product
     cards; a sold-out headline or help strip met on the way is revealed with
     them. Delegated from the document, so it keeps working after facets.js
     re-renders the grid for a filter or sort change. */
  function showMore(btn) {
    var wrap = btn.closest('[data-wf-more]');
    var grid = document.getElementById('product-grid');
    if (!wrap || !grid) return;
    var batch = Number(wrap.getAttribute('data-wf-batch')) || 16;
    var hidden = grid.querySelectorAll('.wf-stock-more');
    var shownNow = 0;
    var firstNew = null;
    for (var i = 0; i < hidden.length; i++) {
      var item = hidden[i];
      var isCard = !item.classList.contains('wf-soldout-divider') && !item.classList.contains('wf-help');
      if (isCard && shownNow === batch) break;
      item.classList.remove('wf-stock-more');
      if (isCard) {
        shownNow++;
        if (!firstNew) firstNew = item;
      }
    }

    var total = grid.querySelectorAll('.grid__item:not(.wf-soldout-divider):not(.wf-help)').length;
    var left = grid.querySelectorAll('.wf-stock-more:not(.wf-soldout-divider):not(.wf-help)').length;
    var shown = wrap.querySelector('[data-wf-shown]');
    if (shown) shown.textContent = String(total - left);
    if (!left) {
      /* Nothing more to show: drop the button, keep the count line. */
      btn.remove();
    }

    /* Keyboard and screen-reader users continue from the first new card. */
    var link = firstNew && firstNew.querySelector('a[href]');
    if (link) link.focus({ preventScroll: true });
  }
})();
